export default __webpack_public_path__ + "static/media/QKart.b4e68b02.png";